<template>
  <section class="flex grow flex-col items-center overflow-hidden">
    <div class="flex size-full justify-center overflow-y-auto">
      <suspense :suspensible="true">
        <component :is="slide" v-for="(slide, index) in slides" v-show="currentIndex === index" :key="index" :variant="cardVariant" />
      </suspense>
    </div>
    <div :class="footerVariant({ intent: cardVariant })">
      <div class="w-full p-2">
        <button :disabled="backDisabled" class="flex flex-row gap-1" @click="goBack">
          <gv-icon-sharp name="chevron_backward" class="fill-surface-on" :class="{ 'opacity-[0.38]': backDisabled }" />
          <span class="text-primary" :class="{ 'sr-only': backDisabled }">Last</span>
        </button>
      </div>
      <mep-page-indicator :pages="slides.length" :current-page="currentIndex + 1" />
      <div class="flex w-full justify-end p-2">
        <button :disabled="nextDisabled" class="flex flex-row gap-1" @click="goNext">
          <span class="text-primary" :class="{ 'sr-only': nextDisabled }">Next</span>
          <gv-icon-sharp name="chevron_forward" class="fill-surface-on" :class="{ 'opacity-[0.38]': nextDisabled }" />
        </button>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { computed, ref, defineEmits, onMounted } from 'vue';
import type { Component } from 'vue';
import { MepLevelInfoCardVariants } from './MepLevelInfoCard/types';
import { cva } from 'class-variance-authority';
import { tw } from '@/common';

const props = withDefaults(
  defineProps<{
    slides: Array<Component>;
    cardVariant: MepLevelInfoCardVariants;
  }>(),
  {
    cardVariant: 'inline',
  }
);

const emit = defineEmits(['slide-change']);

const footerVariant = cva([tw`flex w-full flex-row justify-between pt-2`], {
  variants: {
    intent: {
      inline: tw``,
      modal: tw`p-6`,
    },
  },
});

const currentIndex = ref(0);

const goNext = () => {
  if (currentIndex.value < props.slides.length - 1) {
    currentIndex.value++;
    emit('slide-change', currentIndex.value);
  }
};

const nextDisabled = computed(() => currentIndex.value >= props.slides.length - 1);

const goBack = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--;
    emit('slide-change', currentIndex.value);
  }
};

const backDisabled = computed(() => currentIndex.value <= 0);

onMounted(() => {
  emit('slide-change', currentIndex.value);
});
</script>
